import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { safeRedirect } from '../../utils/safeRedirect';

function hasValidLocalAuth() {
  const userId = localStorage.getItem('user_id');
  // Access token is stored in cookies by AuthContext
  const accessToken = document.cookie
    .split('; ')
    .find((row) => row.startsWith('access_token='))
    ?.split('=')[1];

  // Per requirement we primarily check localStorage.
  // We also require access_token cookie so AuthContext initialization & protected screens work reliably.
  return Boolean(userId && accessToken);
}

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  // AuthContext is used for loading state so we don't flash redirects during init.
  const { loading, isVerified } = useContext(AuthContext);

  const isAuthed = hasValidLocalAuth();

  if (loading) return null;

  if (!isAuthed) {
    const currentPath = location.pathname + location.search;
    return (
      <Navigate to={`/login?redirect=${encodeURIComponent(safeRedirect(currentPath))}`} replace />
    );
  }

  // Block dashboard access until email verification is complete.
  if (isAuthed && isVerified === false) {
    if (location.pathname === '/email-verification') return children;

    const currentPath = location.pathname + location.search;
    return (
      <Navigate
        to={`/email-verification?redirect=${encodeURIComponent(safeRedirect(currentPath))}`}
        replace
      />
    );
  }

  return children;
};

export default ProtectedRoute;
